import React, { Component } from 'react';
import { connect } from 'react-redux';

import NotificationItem from './NotificationItem';
import { updateNotification, toggleNotification } from '../../../store/notifications/actions';
import * as fromNotifications from '../../../store/notifications/reducer';
import { onSearchChange } from '../../../store/files/actions';
import './notifications.css';

class Notifications extends Component {
	constructor() {
		super();

		this.handleNotificationClick = this.handleNotificationClick.bind(this);
	}
	componentDidMount() {
		const { newNotifications, updateNotification } = this.props;

		if (newNotifications.length) {
			newNotifications.forEach(notification => {
				updateNotification(notification.id);
			});
		}
	}

	handleNotificationClick(title) {
		const newFile = "New File Added - ";

		if (title.startsWith(newFile)) {
			const { onSearchChange, history } = this.props;

			onSearchChange(title.replace(newFile, ""));
			history.push('/my-files');
		}
	}

	render() {
		const { notifications, toggleNotification } = this.props;
	
		return (
			<div className="notifications">
				<div className="notifications__header">
					<h1 className="notifications__title">Notifications</h1>
				</div>
				<div className="notifications__body">
					<ul className="notifications__group">
						{
							notifications.map(notification => {
								return (
									<NotificationItem 
									 key={notification.id} 
									 notification={notification}
									 handleNotificationClick={this.handleNotificationClick}
									 handleNotificationCollapse={toggleNotification} />
								)
							})
						}
					</ul>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		notifications: fromNotifications.getNotifications(state.notifications),
		newNotifications: fromNotifications.getNewNotifications(state.notifications),
	}
}

export default connect(mapStateToProps, { updateNotification, onSearchChange, toggleNotification })(Notifications);


// WEBPACK FOOTER //
// ./src/components/routes/Notifications/index.js